import * as React from "react";
import { PropertyFiltersGroupProps, PropertyFiltersProps } from "../typings";
import { RouteStore } from "bernie-core";
import { UitkSecondaryButton } from "uitk-react-button";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { withStores } from "stores";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkNotificationBadge1 } from "uitk-react-badge";
import { PROPERTY_FILTERS } from "../PropertyFilters";
import {
  PropertyFiltersDialog,
  PropertyFilterInDialog,
} from "components/flexComponents/PropertyFilters/dialog/PropertyFiltersDialog";
import { useLocalization } from "@shared-ui/localization-context";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedClickstreamTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing } from "uitk-react-spacing";
import { observer } from "mobx-react";

const ButtonTracked = FlexClickTracker(UitkSecondaryButton);

interface MobilePropertyFiltersProps extends Pick<PropertyFiltersProps, "propertyFilters"> {
  routeStore: RouteStore;
}

export const MobilePropertyFilters = withStores(
  "routeStore",
  "propertyFilters"
)(
  observer((props: MobilePropertyFiltersProps) => {
    const { routeStore, propertyFilters } = props;
    const { formatText } = useLocalization();

    const onClick = () => {
      routeStore.updateSearch({ pwaDialog: "filters" });
    };

    const totalFilter = propertyFilters.getNumberOfSelectedFilters();

    return (
      <UitkSpacing padding={{ blockend: "two" }}>
        <div className="uitk-cell all-cell-1-1">
          <ButtonTracked
            moduleName={PROPERTY_FILTERS}
            rfrr="mobileCta"
            isFullWidth={true}
            onClick={onClick}
            icon="tune"
          >
            <>
              <UitkSpacing margin={{ inline: "two" }}>
                <span>{formatText("propertyfilters.filter")}</span>
              </UitkSpacing>
              {totalFilter > 0 && <UitkNotificationBadge1 text={String(totalFilter)} />}
            </>
          </ButtonTracked>
          <PropertyFiltersDialog>
            <UitkSpacing padding={{ inline: "three" }}>
              <div className="SortAndFilters">
                {propertyFilters.getListOfFilters().map((filter, index) => (
                  <PropertyFiltersGroup key={`${filter.name}-${index}`} filter={filter} />
                ))}
              </div>
            </UitkSpacing>
          </PropertyFiltersDialog>
        </div>
      </UitkSpacing>
    );
  })
);

/**
 * Represents a filter group (e.g. Popular Filters)
 * @param props
 * @constructor
 */
const PropertyFiltersGroup = (props: PropertyFiltersGroupProps) => {
  const { filter } = props;
  const { formatText } = useLocalization();
  const track = useClickTracker();

  const callback = (filterNameAndShowMoreOrLess: string) => {
    const flexTracking: FlexTrackingInfo = {
      moduleName: PROPERTY_FILTERS,
      rfrr: filterNameAndShowMoreOrLess, // e.g. stars.ShowMore
      action: Action.CLICK,
    };

    sendDelayedClickstreamTrackEvent(flexTracking, track);
  };

  return (
    <UitkSpacing padding={{ blockend: "six" }} margin={{ block: "six" }}>
      <UitkExpandoPeek
        collapseHeight={180}
        collapseLabel={formatText("propertyfilter.seeLess")}
        expandLabel={formatText("propertyfilter.seeMore")}
        className="uitk-card-separator-bottom"
        analytics={{
          id: filter!.name,
          callback,
        }}
      >
        <PropertyFilterInDialog {...props} />
      </UitkExpandoPeek>
    </UitkSpacing>
  );
};
